export default {
  profile: {},
  groups: [],
  zones: [],
  poles: [],
  buildings: [],
  tags: [],
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  currentDevice: {}
}
